(function (global, factory) {
    typeof exports === 'object' && typeof module !== 'undefined' ? factory(exports, require('react'), require('@mui/material/styles')) :
    typeof define === 'function' && define.amd ? define(['exports', 'react', '@mui/material/styles'], factory) :
    (global = typeof globalThis !== 'undefined' ? globalThis : global || self, factory(global['@freska-fi/ui-theme'] = {}, global.React, global.styles));
}(this, (function (exports, React, styles) { 'use strict';

    function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

    var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

    /*! *****************************************************************************
    Copyright (c) Microsoft Corporation.

    Permission to use, copy, modify, and/or distribute this software for any
    purpose with or without fee is hereby granted.

    THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
    REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
    AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
    INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
    LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
    OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
    PERFORMANCE OF THIS SOFTWARE.
    ***************************************************************************** */

    var __assign = function() {
        __assign = Object.assign || function __assign(t) {
            for (var s, i = 1, n = arguments.length; i < n; i++) {
                s = arguments[i];
                for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
            }
            return t;
        };
        return __assign.apply(this, arguments);
    };

    var typography = {
        fontFamily: "'Nunito Sans', Helvetica, sans-serif",
        fontWeightBold: 700,
        h1: {
            fontSize: 44,
            fontWeight: 900,
            lineHeight: 1,
        },
        h2: {
            fontSize: 35,
            fontWeight: 900,
            lineHeight: 1,
        },
        h3: {
            fontSize: 25,
            fontWeight: 900,
        },
        body1: {
            fontSize: 20,
            lineHeight: 1.4,
        },
        body2: {
            fontSize: 17,
            lineHeight: 1.41,
        },
        subtitle1: {
            fontSize: 24,
            fontWeight: 600,
            lineHeight: 1.5,
        },
        subtitle2: {
            fontSize: 20,
            fontWeight: 600,
            lineHeight: 1.4,
        },
        caption: {
            fontSize: 14,
            lineHeight: 1.35,
        },
        overline: {
            fontSize: 12,
            fontWeight: 900,
            lineHeight: 1.33,
            textTransform: 'uppercase',
            letterSpacing: 1,
        },
        button: {
            fontWeight: 900,
            lineHeight: 1.4,
            textTransform: 'none',
        },
    };
    var palette = {
        primary: {
            light: '#c0c7ed',
            main: '#1a237e',
            dark: '#000552',
        },
        secondary: {
            light: '#e9f5f9',
            main: '#b3e3f2',
            dark: '#8bc8db',
        },
        info: {
            light: '#e9f5f9',
            main: '#b3e3f2',
            dark: '#8bc8db',
        },
        success: {
            light: '#d5f1e2',
            main: '#76d2ab',
            dark: '#41a870',
        },
        error: {
            light: '#ffccc9',
            main: '#ff6f64',
            dark: '#ee4948',
        },
        warning: {
            light: '#fdded3',
            main: '#F9D853',
            dark: '#fa8d68',
        },
        grey: {
            // TODO: Not sure if this makes sense
            A100: '#f0f1f4',
            A200: '#dadbe3',
            A400: '#949ea9',
        },
        action: {
            disabled: '#949ea9',
            disabledBackground: '#f0f1f4',
        },
        text: {
            primary: '#21252b',
            secondary: '#949ea9',
            disabled: '#949ea9',
        },
        background: {
            default: '#f0f1f4',
        },
        divider: '#dadbe3',
    };
    var shadows = [
        'none',
        'rgba(0, 5, 82, 0.08) 0px 7px 14px 0px',
        'rgba(0, 5, 82, 0.08) 0px 7px 14px 0px',
        'rgba(0, 5, 82, 0.08) 0px 7px 14px 0px',
        'rgba(0, 5, 82, 0.08) 0px 7px 14px 0px',
        'rgba(0, 5, 82, 0.08) 0px 7px 14px 0px',
        'rgba(0, 5, 82, 0.08) 0px 7px 14px 0px',
        'rgba(0, 5, 82, 0.08) 0px 7px 14px 0px',
        'rgba(0, 5, 82, 0.08) 0px 7px 14px 0px',
        'rgba(0, 5, 82, 0.08) 0px 7px 14px 0px',
        'rgba(0, 5, 82, 0.08) 0px 7px 14px 0px',
        'rgba(0, 5, 82, 0.08) 0px 7px 14px 0px',
        'rgba(0, 5, 82, 0.08) 0px 7px 14px 0px',
        'rgba(0, 5, 82, 0.08) 0px 7px 14px 0px',
        'rgba(0, 5, 82, 0.08) 0px 7px 14px 0px',
        'rgba(0, 5, 82, 0.08) 0px 7px 14px 0px',
        'rgba(0, 5, 82, 0.08) 0px 7px 14px 0px',
        'rgba(0, 5, 82, 0.08) 0px 7px 14px 0px',
        'rgba(0, 5, 82, 0.08) 0px 7px 14px 0px',
        'rgba(0, 5, 82, 0.08) 0px 7px 14px 0px',
        'rgba(0, 5, 82, 0.08) 0px 7px 14px 0px',
        'rgba(0, 5, 82, 0.08) 0px 7px 14px 0px',
        'rgba(0, 5, 82, 0.08) 0px 7px 14px 0px',
        'rgba(0, 5, 82, 0.08) 0px 7px 14px 0px',
        'rgba(0, 5, 82, 0.08) 0px 7px 14px 0px',
    ];
    function createFreskaTheme() {
        var _a;
        var theme = styles.createTheme({
            typography: typography,
            palette: palette,
            shadows: shadows,
        });
        theme.typography.h1 = __assign(__assign({}, theme.typography.h1), (_a = {}, _a[theme.breakpoints.down('xs')] = {
            fontSize: 35,
        }, _a));
        theme.components = __assign(__assign({}, theme.components), { MuiFilledInput: {
                styleOverrides: {
                    root: {
                        backgroundColor: theme.palette.common.white,
                        border: "1px solid " + theme.palette.divider,
                        borderRadius: '8px',
                        borderTopLeftRadius: '8px',
                        borderTopRightRadius: '8px',
                        '&::before': {
                            display: 'none',
                        },
                        '&::after': {
                            display: 'none',
                        },
                        '&:hover': {
                            backgroundColor: theme.palette.common.white + " !important",
                        },
                        '&.Mui-focused': {
                            backgroundColor: theme.palette.common.white,
                            borderColor: theme.palette.primary.main,
                        },
                        '&.Mui-disabled': {
                            background: 'transparent !important',
                            borderColor: 'transparent',
                            cursor: 'not-allowed',
                        },
                        '&.Mui-error': {
                            borderColor: theme.palette.error.main,
                        },
                    },
                    multiline: {
                        lineHeight: 1.33,
                        paddingTop: 16,
                        paddingBottom: 16,
                    },
                },
            }, MuiFormControlLabel: {
                styleOverrides: {
                    root: {
                        alignItems: 'flex-start',
                    },
                    label: {
                        marginTop: 9,
                        fontSize: 17,
                        color: theme.palette.primary.main,
                    },
                },
            }, MuiSelect: {
                styleOverrides: {
                    root: {
                        '&:focus': {
                            backgroundColor: "transparent !important",
                        },
                    },
                },
            } });
        return theme;
    }

    function ThemeProvider(_a) {
        var _b = _a.theme, theme = _b === void 0 ? createFreskaTheme() : _b, children = _a.children;
        return React__default['default'].createElement(styles.ThemeProvider, { theme: theme }, children);
    }

    exports.createFreskaTheme = createFreskaTheme;
    exports.default = ThemeProvider;

    Object.defineProperty(exports, '__esModule', { value: true });

})));
